module.exports = __webpack_public_path__ + "static/img/background.95864432.svg";